import { createFileRoute } from "@tanstack/react-router";
import { SubServicePage } from "@/components/SubServicePage";
import { SEO_SITE, hreflangLinks, ctaDesc, ctaTitle } from "@/lib/seo";

const meta = {"th":{"h1":"รับรองลายมือชื่อโดย Notarial Services Attorney — ในไทย","metaTitle":"Notary Public Thailand — รับรองลายมือชื่อ | Same-day | NYC","metaDesc":"รับรองลายมือชื่อ (Signature Notarisation) โดยทนายผู้ทำคำรับรอง (Notarial Services Attorney) จากสภาทนายความไทย ใช้ต่างประเทศ+Apostille"},"en":{"h1":"Signature Notarisation by Thai Notarial Services Attorney","metaTitle":"Notary Public Thailand — Signature Notarisation Same-day | NYC","metaDesc":"Signature notarisation by a registered Notarial Services Attorney of the Lawyers Council of Thailand. Pair with Apostille for overseas use."}} as const;

export const Route = createFileRoute("/en/notary/certify-signature")({
  head: () => {
    const url = `${SEO_SITE}/en/notary/certify-signature`;
    const c = meta.en;
    return {
      meta: [
        { title: ctaTitle(c.metaTitle, "/en/notary/certify-signature", "en")},
        { name: "description", content: ctaDesc(c.metaDesc, "/en/notary/certify-signature", "en")},
        { property: "og:title", content: ctaTitle(c.metaTitle, "/en/notary/certify-signature", "en")},
        { property: "og:description", content: ctaDesc(c.metaDesc, "/en/notary/certify-signature", "en")},
        { property: "og:url", content: url },
        { property: "og:type", content: "website" },
        { property: "og:locale", content: "en_US" },
        { name: "twitter:card", content: "summary_large_image" },
      ],
      links: [{ rel: "canonical", href: url }, ...hreflangLinks("/notary/certify-signature", "/en/notary/certify-signature")],
    };
  },
  component: () => <SubServicePage slug="notary/certify-signature" locale="en" />,
});
